// @flow
import { call, put, takeEvery, select } from 'redux-saga/effects'
import querystring from 'src/helpers/query-string'
import { updateEncryptionState, ENCRYPT_VALUES, DECRYPT_VALUES } from './'
import { encrypt, decrypt } from 'src/helpers/encrypt'
import type { State } from 'src/types/redux'

const getShortUrl = longUrl => {
  return fetch(
    `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${process.env
      .REACT_APP_FIREBASE_API_KEY || ''}`,
    {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        dynamicLinkInfo: {
          dynamicLinkDomain: process.env.REACT_APP_DYNAMIC_LINK_DOMAIN,
          link: `${longUrl}`
        }
      })
    }
  )
    .then(response => response.json())
    .then(json => json.shortLink)
}

const getLongUrl = values => {
  const { location, roomType } = values
  const qs = querystring.stringify(values)
  const hash = encrypt(qs)
  return `${process.env.REACT_APP_URL || ''}/${location}/${roomType}?data=${hash}`
}

export const getLocationSearch = (state: State) => state.router.location.search

function* encryptionWorker(action) {
  const { payload } = action
  const longUrl = getLongUrl(payload)
  const shortUrl = yield call(getShortUrl, longUrl)
  yield put(updateEncryptionState({ longUrl, shortUrl }))
}

function* decryptionWorker(action) {
  let search = yield select(getLocationSearch)
  const qs = querystring.parse(search)
  if (Object.prototype.hasOwnProperty.call(qs, 'data')) {
    // $FlowFixMe
    const { values } = decrypt(qs.data)
    const parsed = querystring.parse(values)
    yield put(updateEncryptionState({ decrypted: { ...parsed } }))
  }
}

// $FlowFixMe
export function* encryptionSaga() {
  // $FlowFixMe
  yield takeEvery([ENCRYPT_VALUES], encryptionWorker)
  // $FlowFixMe
  yield takeEvery([DECRYPT_VALUES], decryptionWorker)
}



// WEBPACK FOOTER //
// ./src/ducks/encryption/sagas.js